import { EuObjectives } from '@upright/common/model/input/eu-taxonomy/types';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';

interface ImpactCategoryByEuObjective {
  [id: string]: ImpactCategoryId[];
}

interface EuObjectivesByImpactCategory {
  [id: string]: EuObjectives[];
}

const euObjectiveImpactMapping: ImpactCategoryByEuObjective = {
  [EuObjectives.adaptation]: [ImpactCategoryId.GHG_EMISSIONS],
  [EuObjectives.mitigation]: [ImpactCategoryId.GHG_EMISSIONS],
  [EuObjectives.pollution]: [ImpactCategoryId.NON_GHG_EMISSIONS],
  [EuObjectives.biodiversity]: [ImpactCategoryId.BIODIVERSITY],
  [EuObjectives.circular]: [ImpactCategoryId.WASTE],
  [EuObjectives.water]: [ImpactCategoryId.SCARCE_NATURAL_RESOURCES],
};

function prepareEuObjectivesByImpactCategory() {
  const objectives = Object.keys(euObjectiveImpactMapping) as EuObjectives[];
  const ret: EuObjectivesByImpactCategory = {};
  objectives.forEach(objective => {
    const impacts = euObjectiveImpactMapping[objective];
    impacts.forEach(impact => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!ret[impact]) {
        ret[impact] = [];
      }
      ret[impact].push(objective);
    });
  });
  return ret;
}

const impactEuObjectivesMapping: EuObjectivesByImpactCategory = prepareEuObjectivesByImpactCategory();

export function getEuObjectivesForImpactCategory(id: ImpactCategoryId): EuObjectives[] {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return impactEuObjectivesMapping[id] || [];
}
